export const BASICSETUP_GET = 'BASICSETUP_GET';
export const BASICSETUP_ERROR = 'BASICSETUP_ERROR';
export const BASICSETUP_CLEAR = 'BASICSETUP_CLEAR';
export const BASICSETUP_UPDATE_COLLECTION = 'BASICSETUP_UPDATE_COLLECTION';
export const BASICSETUP_LOADING = 'BASICSETUP_LOADING';



// WEBPACK FOOTER //
// ./src/components/basicsetup/state/types.js